const API_URLS = {
  // ============================================
  // LOGIN & AUTHENTICATION
  // ============================================
  Login: "/users/login/",
  VerifyOTP: "/users/verify-otp/",
  GetAadhaar: "/users/get-aadhar/",
  FarmerAadhaarCard: "/users/farmer-aadhar-card/",
  CheckAadhaar: "/users/farmer/check-aadhar/",
  RegisterNonFarmer: "/users/farmer/register-non-farmer/",
  RegisterProductionCenter: "/users/register-production-center/",

  // ============================================
  // BILLING & PDF
  // ============================================
  GenerateBill: "/users/generate-bill-pdf/",

  // ============================================
  // PRODUCTION CENTER
  // ============================================
  ProductionCenter: "/center/production-centers/",
  ProductionCenterType: "/center/production-center-types/",
  GetNearbyCenters: "/center/production-centers-nearby/",
  GetproductionCnt: "/users/production-counts/",
  GetProMontSalce: "/users/production-monthly-sales/",
  Getproductioncenters: "/users/production-centers",
  Getproduct: "/productioncenter",
  Postorderplc: "/users/order-placed",
  GetMap: "users/production-centers/map",
  GetTargetSchemes: "/center/target-schemes/",
  // ============================================
  // FARMERS
  // ============================================
  Farmers: "/users/farmer-request/",
  FarmerAadhar: "/users/farmer-aadhar/",
  GetfarmerDetails: "/users/farmer-details/",
  GetfarmerRequest: "/users/farmer-request/",
  PutApproveitem: "/users/approve-item/",
  Requestheader: "/users/request-header/",
  GetWeekReport: "/users/farmer-request-weekly-report",

  // ============================================
  // SPECIES & STOCK
  // ============================================
  species: "/center/stock-details/",
  GetSpecies: "/center/trees/",
  StockDetails: "/center/stock-details/",
  saplingsUrl: "/users/production-saplings/",
  GetBlockSumar: "/center/blocksummary/",

  // ============================================
  // SCHEMES
  // ============================================
  scheme: "/center/schema/",
  Schemes: "/targetdepartment/schemes/all",

  // ============================================
  // MASTER DATA (DISTRICTS, BLOCKS, VILLAGES)
  // ============================================
  GetDistricts: "/master/districts/",
  GetBlocks: "/master/blocks/",
  GetVillages: "/master/villages/",

  // ============================================
  // ALLOCATIONS
  // ============================================
  allocations: "/users/farmer-request/",
  AllocationSummaryAll: "/targetdepartment/allocation-summary-all",

  // ============================================
  // OFFICERS & DEPARTMENTS
  // ============================================
  Officer: "/officers/officer/",
  Department: "/officers/departments",
  Degisnation: "/officers/designations",
  Role: "/users/roles",
  OfficerRegistration: "/officers/register-officer",
  PostofficerRegister: "/officers/register",
  GetofficerProfile: "/officer/profile",
  Contact: "/officers/Contact/",

  // ============================================
  // TARGETS
  // ============================================
  DepartmentTarget: "/targetdepartment",
  DistrictTarget: "/targetdistrict",
  BlockTarget: "/targetblock",
  NurseryTarget: "/targetproductioncenter",
  GetTarget: "/users/target-details/",

  // ============================================
  // DASHBOARD
  // ============================================
  GetTopCenters: "/users/dashboard/top-centers",
  GetDistrictSamplings: "/users/dashboard/district-saplings",
  GetusrDashboardCnt: "/users/dashboard-counts",
  GetSalesurl: "/users/production-monthly-sales/",
  GetpendingUrl: "/users/farmer-request/",

  // ============================================
  // USER PROFILE
  // ============================================
  GetUserProfile: "/user/profile/",

  // ============================================
  // INSPECTIONS - UPDATED FOR NEW FLOW
  // ============================================

  GetFormersOrders: "/officers/get-formers-orders/",

  // NEW: Create inspection - Field inspector starts inspection
  // Body: { request_id, farmer_id, field_inspector_id }
  CreateInspection: "/officers/create-inspection",

  // Upload inspection details with image (multipart/form-data)
  // Body: { inspection_id, inspection_address, latitude, longitude, survey_count, inspected_by, sapplings, image }
  UploadInspectionSappling: "/officers/upload-inspection-sappling",

  // Approve inspection
  // Usage: ApproveInspection + inspection_id
  ApproveInspection: "/officers/approve-inspection/",

  // Reject inspection
  // Usage: RejectInspection + inspection_id
  // Body: { reason_for_reject: "..." }
  RejectInspection: "/officers/reject-inspection/",

  // REMOVED: AssignInspection - No longer needed in new flow
  // Field inspectors directly inspect without assignment

  // Dynamic contolers
  DashboardCarousel: "/dynamic/dashboard-carousel",
  DashboardSchemes: "/dynamic/dashboard-schemes",
  UploadDashboardCarousel: "/dynamic/dashboard-carousel/upload",
  DeleteDashboardCarousel: "/dynamic/dashboard-carousel/delete",
  DeleteDashboardSchemes: "/dynamic/dashboard-schemes",
  UploadDashboardSchemes: "/dynamic/dashboard-schemes/upload",
  UpdateDashboardSchemes: "/dynamic/dashboard-schemes",
};

export default API_URLS;
